// Mock data + constants for The Loom V2.38_f55

export const GENRES = [
  { id: 'fantasy',   label: 'Fantasy',           sub: 'High / Low / Urban' },
  { id: 'scifi',     label: 'Science Fiction',   sub: 'Hard / Space Opera' },
  { id: 'thriller',  label: 'Thriller / Suspense', sub: 'Psychological / Action' },
  { id: 'mystery',   label: 'Mystery / Crime',   sub: 'Cozy / Noir' },
  { id: 'romance',   label: 'Romance',           sub: 'Contemporary / Historical' },
  { id: 'horror',    label: 'Horror',            sub: 'Gothic / Cosmic' },
  { id: 'literary',  label: 'Literary Fiction',  sub: 'Character-driven' },
  { id: 'historical',label: 'Historical Fiction', sub: 'Period / Alt-history' },
  { id: 'ya',        label: 'Young Adult',       sub: 'Coming-of-age' },
  { id: 'dystopian', label: 'Dystopian',         sub: 'Post-apocalyptic' },
];

export const MODES = [
  {
    id: 'outline',
    title: 'Outlining',
    glyph: 'Compass',
    accent: 'chart-2',
    goal: 'Architect the skeleton, beats, and arcs.',
    keys: ['Plot hole detection', 'Act structure', 'Subplot density', 'Arc progression', 'Brainstorming divergence', 'Glossary enforcement', 'Backstory reveal', 'Reference: full novel']
  },
  {
    id: 'draft',
    title: 'Drafting',
    glyph: 'PenLine',
    accent: 'chart-1',
    goal: 'Maximum prose output with momentum.',
    keys: ['Autocomplete aggressiveness', 'Continuation length', 'Pacing', 'Show-vs-tell', 'Dialogue formality', 'Sentence variance', 'Sensory balance', 'AI invocation', 'Auto-save']
  },
  {
    id: 'revise',
    title: 'Revision',
    glyph: 'Wand2',
    accent: 'chart-3',
    goal: 'Refine, tighten, polish to publication.',
    keys: ['Rewrite variations', 'Grammar strictness', 'Cliché flagging', 'Consistency alerts', 'Readability target', 'Emotional valence', 'Suspense ramp', 'Sentiment arc']
  },
  {
    id: 'world',
    title: 'World-Builder',
    glyph: 'Globe2',
    accent: 'chart-4',
    goal: 'Deep, consistent, epic lore systems.',
    keys: ['Exposition density', 'Glossary lock', 'Magic/tech rule consistency', 'Setting novelty', 'Subplot density', 'Reference: full novel']
  },
];

export const VARIABLE_GROUPS = [
  {
    id: 'plot',
    title: 'Plot & Structure',
    glyph: 'GitBranch',
    items: [
      { id: 'plotholes',    label: 'Plot Hole Detection',  range: ['Low','High'],            value: 72 },
      { id: 'pacing',       label: 'Pacing',               range: ['Slow','Fast'],           value: 60 },
      { id: 'chapterlen',   label: 'Chapter Length',       range: ['1k','5k words'],         value: 55, unit: 'k' },
      { id: 'subplot',      label: 'Subplot Density',      range: ['Sparse','Dense'],        value: 45 },
    ]
  },
  {
    id: 'character',
    title: 'Character',
    glyph: 'Users',
    items: [
      { id: 'voice',        label: 'Voice Consistency',    range: ['Weak','Strong'],         value: 82 },
      { id: 'dialogue',     label: 'Dialogue Formality',   range: ['Slang','Formal'],        value: 50 },
      { id: 'monologue',    label: 'Internal Monologue',   range: ['Rare','Frequent'],       value: 40 },
      { id: 'arcspeed',     label: 'Arc Progression',      range: ['Slow','Fast'],           value: 55 },
    ]
  },
  {
    id: 'prose',
    title: 'Prose Style',
    glyph: 'Type',
    items: [
      { id: 'variance',     label: 'Sentence Variance',    range: ['Uniform','Wild'],        value: 70 },
      { id: 'metaphor',     label: 'Metaphor / Simile',    range: ['None','Dense'],          value: 55 },
      { id: 'showtell',     label: 'Show vs Tell',         range: ['Tell','Show'],           value: 75 },
      { id: 'sensory',      label: 'Sensory Detail',       range: ['Minimal','Immersive'],   value: 65 },
    ]
  },
  {
    id: 'tone',
    title: 'Tone & Mood',
    glyph: 'Flame',
    items: [
      { id: 'valence',      label: 'Emotional Valence',    range: ['Optimistic','Grim'],     value: 58 },
      { id: 'humor',        label: 'Humor vs Serious',     range: ['Funny','Deadly'],        value: 35 },
      { id: 'tension',      label: 'Suspense Ramp',        range: ['Flat','Exponential'],    value: 72 },
      { id: 'heat',         label: 'Romantic Heat',        range: ['None','Intense'],        value: 25 },
    ]
  },
];

export const TOGGLES = {
  tense: ['Past', 'Present'],
  pov:   ['1st', '3rd Limited', '3rd Omni'],
};

export const CHARACTERS = [
  {
    id: 'c1',
    name: 'Lyra Ashford',
    role: 'Protagonist',
    age: 27,
    archetype: 'The Reluctant Hero',
    color: 'chart-1',
    traits: [
      { k: 'Courage',     v: 65 },
      { k: 'Empathy',     v: 82 },
      { k: 'Cunning',     v: 48 },
      { k: 'Discipline',  v: 70 },
      { k: 'Compassion',  v: 78 },
    ],
    description: 'A cartographer turned rebel after the fall of the Northern Reach. Carries an old family debt and a quiet fear of becoming her father.',
    voice: 'Dry, observational, sparing with words; warms in moments of grief.',
    arc: [40, 38, 45, 52, 50, 58, 64, 60, 70, 72, 78, 76, 80, 82, 86, 84, 88, 90, 92, 95],
  },
  {
    id: 'c2',
    name: 'Magister Halden',
    role: 'Mentor / Antagonist',
    age: 58,
    archetype: 'The Fallen Teacher',
    color: 'chart-3',
    traits: [
      { k: 'Courage',     v: 70 },
      { k: 'Empathy',     v: 30 },
      { k: 'Cunning',     v: 90 },
      { k: 'Discipline',  v: 88 },
      { k: 'Compassion',  v: 22 },
    ],
    description: 'A former Magister of the Astral Order, exiled for a heresy he refuses to disavow. Believes that mercy is a weakness that costs empires.',
    voice: 'Measured, paternal, slow cadence. Quotes scripture when angry.',
    arc: [70, 72, 70, 68, 65, 62, 60, 55, 58, 52, 48, 44, 42, 40, 36, 32, 28, 25, 20, 18],
  },
  {
    id: 'c3',
    name: 'Brennan Vell',
    role: 'Ally',
    age: 31,
    archetype: 'The Loyal Rogue',
    color: 'chart-4',
    traits: [
      { k: 'Courage',     v: 78 },
      { k: 'Empathy',     v: 60 },
      { k: 'Cunning',     v: 75 },
      { k: 'Discipline',  v: 42 },
      { k: 'Compassion',  v: 55 },
    ],
    description: 'A smuggler with a moral code nobody else seems to remember. Owes Lyra a life-debt from the Glasswater incident.',
    voice: 'Wry, fast-talking, deflects pain with humor. Goes quiet when serious.',
    arc: [55, 58, 60, 62, 58, 60, 65, 68, 64, 70, 72, 70, 75, 78, 80, 76, 82, 84, 85, 88],
  },
  {
    id: 'c4',
    name: 'Sera Thal',
    role: 'Love Interest',
    age: 26,
    archetype: 'The Hidden Heir',
    color: 'chart-2',
    traits: [
      { k: 'Courage',     v: 60 },
      { k: 'Empathy',     v: 88 },
      { k: 'Cunning',     v: 55 },
      { k: 'Discipline',  v: 64 },
      { k: 'Compassion',  v: 90 },
    ],
    description: 'A healer with a memory she cannot account for. The dreams have started again.',
    voice: 'Soft, lyrical, fond of metaphors drawn from herbalism and weather.',
    arc: [42, 44, 46, 50, 54, 58, 62, 65, 68, 70, 72, 74, 78, 80, 82, 84, 85, 87, 88, 90],
  },
];

function statusForChapterIndex(i) {
  if (i < 6) return 'final';
  if (i < 12) return 'draft';
  if (i < 16) return 'outline';
  return 'planned';
}

export const CHAPTERS = Array.from({ length: 20 }, (_, i) => {
  const titles = [
    'The Ledger of Salt','A Map Drawn in Ash','The Glasswater Pact','Hounds of the Reach',
    'Letters Never Sent','The Magister\'s Garden','Below the Lighthouse','What the River Knows',
    'A Coronation in Smoke','The Cartographer\'s Daughter','Mercy as a Weapon','The Quiet Heresy',
    'Bone, Bell, and Banner','The Tower in the Fog','Hands That Remember','The Astral Court',
    'A Promise Unsworn','The Last Margrave','When the Stars Fall Twice','The Door at the End of Maps',
  ];
  return {
    id: `ch${i + 1}`,
    number: i + 1,
    title: titles[i],
    words: 2400 + Math.floor(Math.random() * 1800),
    status: statusForChapterIndex(i),
    sentiment: Math.sin(i / 3) * 0.5 + (i / 20) * 0.4 + 0.1,
  };
});

export const SAMPLE_CHAPTER = {
  title: 'Chapter 1 \u2014 Untitled',
  paragraphs: [
    { id: 'p1', text: '' },
  ],
};

export const CHAT_SEED = [];

export const ANALYSIS = {
  chapter: {
    continuity: 96,
    pacing: 72,
    sentiment: -0.18,
    plotholes: 1,
    cliches: 3,
    readability: 8.6,
  },
  novel: {
    continuity: 91,
    pacing: 68,
    plotholes: 4,
    cliches: 17,
    readability: 8.9,
    voiceDrift: 7,
  },
};

export const TOKENS = {
  used:   1_842_330,
  budget: 3_000_000,
  rateIn: 3.00,    // per 1M
  rateOut: 15.00,  // per 1M
  modelId: 'claude-sonnet-4.5',
};
